const branches = {
  branches: {
    pageHeader: 'Niederlassungen',
    addBranchOffice: '+ Niederlassung hinzufügen',
    name: 'Name',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    branches: 'Niederlassungen',
    noBranchAvailable: '** Keine Niederlassungen verfügbar **'
  }
};

export default branches;
